import { Controller } from "@hotwired/stimulus"
import { mount, unmount } from "svelte"
import { saveSmartFieldPlacements } from "@/api/lease_documents"
import PdfFieldMapper from "../components/pdf_field_mapper/PdfFieldMapper.svelte"

export default class extends Controller {
  static values = {
    customFieldsPath: String,
    maxPlacements: Number,
    palette: Array,
    placements: Array,
    savePlacementsPath: String,
    sourcePdfKey: String,
    url: String,
  }

  connect() {
    this.mapper = mount(PdfFieldMapper, {
      props: {
        customFieldsPath: this.customFieldsPathValue,
        maxPlacements: this.maxPlacementsValue,
        palette: this.paletteValue,
        placements: this.placementsValue,
        save: this.savePlacementsPathValue
          ? (placements) =>
              saveSmartFieldPlacements({
                path: this.savePlacementsPathValue,
                placements,
                sourcePdfKey: this.sourcePdfKeyValue,
              })
          : null,
        url: this.urlValue,
      },
      target: this.element,
    })
  }

  disconnect() {
    unmount(this.mapper)
  }
}
